<template>
    <v-btn @click="prueba()" color="primary"> Probar</v-btn>
</template>

<script>
    import axios from 'axios'
    const $ = require('jquery');
    export default {
        name:'app',
        data(){
            return{
                data:null,
                empleados:Object,
            }
        },
        methods:{
            prueba(){
                console.log('prueba')
                var url = 'https://tst.portal.tech.msc.com/trackandtrace/v2.2/events?carrierBookingReference=MEDUIQ240943';
                
                var self = this;
                $.getJSON(url, function (json){
                    self.empleados = json;
                } );    
                /*axios.get(url,this.data,{header:'Access-Control-Allow-Origin'}).then(data => {
                    this.data = data.data;
                })*/
                console.log('self.empleados');
                console.log(self.empleados);
                /*const options = {
                    url: 'https://tst.portal.tech.msc.com/trackandtrace/v2.2/events?carrierBookingReference=MEDUIQ240943',
                    method: 'GET',
                    headers: {
                        'accept': 'application/json'
                    },
                    gzip: true,
                    json: true
                };
                request(options, (err, response, body) => {
                    console.log('success:', body);
                });*/
            }
        },
    }
</script>
